import React from 'react'
import {
  CriteriaText,
  getBathsDisplay,
  getBedsDisplay,
  getChangedCriteriaCount,
  getPriceRangeDisplay
} from './SavedSearchHelpers'
import { Flex, Text } from '@homebotapp/hb-react-component-catalog'
import { ListingsFilters } from '../../../api/gqlaxy/gql/generated/graphql'
import { defineMessages, useIntl } from 'react-intl'

const MSG = defineMessages({
  andXMoreFilters: {
    id: 'HomeSearch.savedSearches.andXMoreFilters',
    defaultMessage: '{num, plural, =1 {and 1 more filter} other {and {num} more filters.}}'
  },
  filters: {
    id: 'HomeSearch.savedSearches.filters',
    defaultMessage: '{num, plural, =1 {1 filter} other {{num} filters}}'
  }
})

interface SavedSearchChangedFiltersDisplayProps {
  savedSearchOrFilter: ListingsFilters | undefined
}

export const SavedSearchChangedFiltersDisplay = ({ savedSearchOrFilter }: SavedSearchChangedFiltersDisplayProps) => {
  const intl = useIntl()
  const getAdditionalCriteriaDisplay = (filterOrSavedSearch: ListingsFilters | undefined) => {
    if (!filterOrSavedSearch) return null
    const changedCriteriaObj = getChangedCriteriaCount(filterOrSavedSearch)
    if (!changedCriteriaObj) return null

    if (changedCriteriaObj?.additionalChangedCriteriaCountExcludingPriceBedsAndBaths > 0) {
      if (changedCriteriaObj?.priceBedsOrBathsWasModified) {
        return (
          <CriteriaText>
            {/* ie "and 8 more filters" or "and 1 more filter" */}
            {intl.formatMessage(MSG.andXMoreFilters, {
              num: changedCriteriaObj.additionalChangedCriteriaCountExcludingPriceBedsAndBaths
            })}
          </CriteriaText>
        )
      } else {
        return (
          <CriteriaText>
            {/* ie "8 filters" or "1 filter" */}
            {intl.formatMessage(MSG.filters, {
              num: changedCriteriaObj.additionalChangedCriteriaCountExcludingPriceBedsAndBaths
            })}
          </CriteriaText>
        )
      }
    } else {
      return null
    }
  }

  return (
    <Flex wrap='wrap' mb={4}>
      {[
        getPriceRangeDisplay(savedSearchOrFilter?.minPrice, savedSearchOrFilter?.maxPrice),
        getBathsDisplay(savedSearchOrFilter?.minBathroomsCount),
        getBedsDisplay(savedSearchOrFilter?.minBedroomsCount),
        getAdditionalCriteriaDisplay(savedSearchOrFilter)
      ]
        .filter(item => item !== null)
        .map((element, index, array) => (
          <React.Fragment key={index}>
            {element}
            {index < array.length - 1 && <Text mr={1} size='sm'>{`,`}</Text>}
          </React.Fragment>
        ))}
    </Flex>
  )
}
